module.exports = {
	"classes": [
		"dashboard-page",
		"header-dark"
	],
	"title": "Dashboard",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/dashboard/metadata.json
// module id = 1118
// module chunks = 0